export default __webpack_public_path__ + "static/media/photo-3.c3501f7c.jpg";